import { render } from "./CompaniesPage.vue?vue&type=template&id=17b41753&scoped=true"
import script from "./CompaniesPage.vue?vue&type=script&lang=js"
export * from "./CompaniesPage.vue?vue&type=script&lang=js"

import "./CompaniesPage.vue?vue&type=style&index=0&id=17b41753&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b41753"]])

export default __exports__